<template>
  <div id="footer" class="container-fluid">
    <div class="container">
      <div class="main">
      <img class="footerImg" src="../assets/img/footer/footerImg.png" alt="">
      <div class="box">
        <div>
          <div class="leftBox">
            <router-link to="/"><img class="footerLogo" src="../assets/img/footer/footerLogo.png" alt=""></router-link>
            <span class="title">上海市宣传文化人才服务中心</span>
          </div>
        </div>
        <div class="centerBox">
          <div class="list">
            <a>中心动态</a>
            <router-link to="/newsAndNotices/news">最新资讯</router-link>
            <router-link to="/newsAndNotices/notices">重要公告</router-link>
          </div>
          <div class="list">
            <a>业务介绍</a>
            <router-link to="/service?current=0">人事管理</router-link>
            <router-link to="/service?current=1">人才招聘</router-link>
            <router-link to="/service?current=2">人才培训</router-link>
            <router-link to="/service?current=3">专业咨询</router-link>
          </div>
          <div class="list">
            <a>服务大厅</a>
            <router-link to="/serviceHall">在线报名</router-link>
          </div>
          <div class="list">
            <a>关于我们</a>
            <router-link to="/aboutUs?index=0">机构介绍</router-link>
            <router-link to="/aboutUs?index=1">联系我们</router-link>
          </div>
        </div>
        <div>
          <div>
            <img class="code" :src="qrcode" alt="">
            <p class="codetext">微信公众号</p>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      qrcode: ''
    };
  },
  mounted() {
    this.getQrcode()
    
    // 清除之前的所有设置
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
    
    if (this.checkTimer) {
      clearInterval(this.checkTimer)
      this.checkTimer = null
    }
    
    // 重置样式
    document.body.style.paddingBottom = ''
    const footer = document.getElementById('footer')
    if (footer) {
      footer.style.position = ''
      footer.style.bottom = ''
      footer.style.left = ''
    }
    
    // 设置页面布局为flex
    document.body.style.display = 'flex'
    document.body.style.flexDirection = 'column'
    document.body.style.minHeight = '100vh'
    
    // 让主内容区域自动填充
    const mainContent = document.querySelector('#app > div:not(#footer)')
    if (mainContent) {
      mainContent.style.flex = '1 0 auto'
    }
  },
  beforeDestroy() {
    // 恢复原始样式
    document.body.style.display = ''
    document.body.style.flexDirection = ''
    document.body.style.minHeight = ''
    
    const mainContent = document.querySelector('#app > div:not(#footer)')
    if (mainContent) {
      mainContent.style.flex = ''
    }
  },
  methods: {
    getQrcode() {
      this.qrcode = localStorage.getItem('qrcode')
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  min-width: 1440px;
  color: #fff;
  background: #242424;
  overflow: hidden;
  text-align: center;
  z-index: 100;
  flex-shrink: 0; /* 防止footer被压缩 */
}

.main {
  position: relative;
  /* width: 1440px; */
  margin: 0 auto;
}

.footerImg {
  width: 100%;
}

.box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 50px 80px;
  display: flex;
  justify-content: space-between;
}

.leftBox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 40px;
  margin-top: -2px;
}

.footerLogo {
  width: 45px;
  margin-right: 5px;
}

.title {
  font-size: 18px;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  font-weight: bold;
  line-height: 2;
  text-align: center;
  z-index: 120;
}

.centerBox {
  flex: 1;
}

.centerBox .list {
  float: left;
  margin-right: 70px;
}

.list a {
  display: block;
  text-align: left;
  margin-bottom: 5px;
  font-size: 14px;
  font-family: "Source Han Sans CN";
  color: rgb(153, 153, 153);
  line-height: 2.571;
  text-decoration: none;
  cursor: pointer;
}
.list a:first-child {
  cursor: default !important;
}

/* .list a:hover {
  color: #FFF;
} */

.list a:first-child {
  font-size: 16px;
  color: rgb(255, 255, 255);
}

.code {
  /* 禁止选中 */
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  /* 禁止拖动 */
  -webkit-touch-callout: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -ms-user-drag: none;
  width: 100px;
}

.codetext {
  font-size: 16px;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  line-height: 2.25;
  text-align: center;
}

@media screen and (max-width: 997px) {
  /* .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
} */
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue